import { Flex, Text } from "@mantine/core";
import React, { Children, ReactElement, ReactNode } from "react";

type InlineDataPosition = "before" | "after" | "flex-end";

const McTitleInlineData: React.FC<{ positionInlineData?: InlineDataPosition }> = ({ children }) => {
  return <>{children}</>;
};

function McTitle({
  children,
  title,
  className = "",
  size = "md",
  ...props
}: React.PropsWithChildren<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    children: ReactNode;
    title: string;
    className?: string;
    size?: "sm" | "md" | "lg";
    inlineData?: ReactNode;
    positionInlineData?: InlineDataPosition;
  }
>) {
  const bodyElements: ReactNode[] = [];
  const inlineElementBefore: ReactNode[] = [];
  const inlineElementAfter: ReactNode[] = [];
  const inlineElementFlexEnd: ReactNode[] = [];

  Children.forEach(children, (child: ReactElement) => {
    if (child?.type !== McTitleInlineData) {
      bodyElements.push(child);
    } else {
      const position = child.props.positionInlineData ?? "before";

      switch (position) {
        case "before":
          inlineElementBefore.push(child);
          break;
        case "after":
          inlineElementAfter.push(child);
          break;
        case "flex-end":
          inlineElementFlexEnd.push(child);
          break;
        default:
          break;
      }
    }
  });

  return (
    <div className={`d-flex flex-column ${className}`} {...props}>
      <Flex gap={0} align="center">
        {inlineElementBefore}
        <Text fw={500} size={size} className="truncateHeaderText">
          {title}
        </Text>
        {inlineElementAfter}
        {inlineElementFlexEnd.length > 0 && (
          <>
            <Flex flex={1} />
            {inlineElementFlexEnd}
          </>
        )}
      </Flex>
      {bodyElements}
    </div>
  );
}

McTitle.InlineData = McTitleInlineData;

export default McTitle;
